import { render, staticRenderFns } from "./ActivityForm.vue?vue&type=template&id=63b78192&"
import script from "./ActivityForm.vue?vue&type=script&lang=js&"
export * from "./ActivityForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports